export default __webpack_public_path__ + "static/media/warningIcon.22af7b0d.svg";